
export type ComparisonResult = -1 | 0 | 1;

export function compareTo(a: number, b: number): ComparisonResult {
  if(a > b) {
    return 1;
  }
  else if(a < b) {
    return -1;
  }
  else {
    return 0;
  }
}
